module.exports = __webpack_public_path__ + "static/media/user_placeholder.99a0a224.png";